var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f61d76099317498d940bf2e1f85d2aa21c6bd4bf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-store@docupet"]={id:"f61d76099317498d940bf2e1f85d2aa21c6bd4bf"};
      